import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deleteSaveVarientSlice = createApi(`DeleteSaveVarientSlice`,"DELETE");

const DeleteSaveVarientSlice = createSlice({
  name: 'DeleteSaveVarientSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteSaveVarientSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSaveVarientSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteSaveVarientSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteSaveVarientSlice.reducer;